import { Component, OnInit } from '@angular/core';
import { Co2SavingsService } from './co2-savings.service';
import { CustomizerSettingsService } from '../../../../customizer-settings/customizer-settings.service';

@Component({
    selector: 'app-co2-savings',
    imports: [],
    templateUrl: './co2-savings.html',
    styleUrl: './co2-savings.scss'
})
export class Co2Savings {
    
    constructor(
        public themeService: CustomizerSettingsService,
        private co2SavingsService: Co2SavingsService
    ) { }

    ngAfterViewInit(): void {
        this.co2SavingsService.loadChart();
    }

    ngOnDestroy(): void {
        this.co2SavingsService.destroyChart();
    }

}